import { Component, OnInit } from '@angular/core';
import { TimelineService } from 'src/app/services/timeline/timeline.service';
import { DatePipe } from '@angular/common';
import { NotifierService } from 'angular-notifier';
import { TripdetailsComponent } from '../trip/tripdetails/tripdetails.component';
import { MatDialog } from '@angular/material';
import { UsersService } from 'src/app/services/users/users.service';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {

  config: any;
  gstcState: any;
  zoom: number = 14;
  scheduled: number = 0;
  completed: number = 0;
  inTransit: number = 0;
  routeName: string;
  routeNames: Array<string> = [];
  schedules: Array<any> = [];
  routes = [];
  rows = {};
  items = {};
  rowTripMapping = [];
  fifteenMinutes = 15 * 60 * 1000;
  isShown: boolean;
  isLoading: boolean;
  openTrip;
  showTooltip;
  userActivityCount = 0;
  userActivityList = [];

  constructor(
    private timelineService: TimelineService,
    private datePipe: DatePipe,
    private notifierService: NotifierService,
    private dialog: MatDialog,
    private userService: UsersService
  ) { }

  ngOnInit() {

    this.isShown = false;
    this.isLoading = true;
    let date = new Date();
    const formattedDate: any = this.datePipe.transform(date, 'yyyy-MM-dd');

    this.timelineService.getSchedulesDTO(formattedDate, formattedDate).subscribe((scheduleDTOList: Array<any>) => {
      console.log(scheduleDTOList);
      this.schedules = scheduleDTOList;
      if(scheduleDTOList && scheduleDTOList.length > 0) {
        this.routeName = scheduleDTOList[0].routeName;
        this.generateData();
        const columns = {
          percent: 100,
          resizer: {
            inRealTime: true
          },
          data: {
            label: {
              id: "label",
              data: "label",
              expander: true,
              isHtml: true,
              width: 230,
              minWidth: 100,
              header: {
                content: this.routeName
              }
            }
          }
        };
  
        let start = new Date();
        start.setHours(7,0,0,0);
        let from = start.getTime();
        start.setHours(21,0,0,0);
        start.setDate(start.getDate());
        let to = start.getTime();
  
        this.config = {
          height: 500,
          list: {
            rows: this.rows,
            columns,
            rowHeight: 45
          },
          chart: {
            items: this.items,
            time: {
              zoom: this.zoom,
              period: 'minute',
              from,
              to,
            }
          },
          actions: {
            'list-column-row': [this.openTrip],
            'chart-timeline-items-row-item' : [this.showTooltip]
          }
        };
      }else {
        this.notifierService.notify('default',"No data to show");
      }

      this.isShown = true;
      this.isLoading = false;
    }, () => {
      this.isLoading = false;
      this.notifierService.notify('error',"Error fetching data..");
    });

    let activityDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.userService.getAllUserActivity(activityDate, activityDate).subscribe(activity => {
      if(activity) {
        this.userActivityCount = activity.length;
        this.userActivityList = activity;
      }
    }, () => {
      this.userActivityCount = 0;
      this.userActivityList = [];
    });

    this.openTrip = (element: HTMLElement, data: any) =>{
      element.addEventListener('click', () => {
        this.rowTripMapping.forEach(mapping => {
          if(mapping.rowId == data.rowId) {
            if(mapping.trip) {
              console.log(mapping.trip);
              let tripDetailsDialog = this.dialog.open(TripdetailsComponent, {
                width: '800px',
                data: {
                  data: mapping.trip
                }
              });

              tripDetailsDialog.updatePosition({
                top: '50px', right: '0px',
              });

              tripDetailsDialog.afterClosed().subscribe(result => {
                console.log(result);
              });
            }else {
              this.notifierService.notify('error',"No trip available for this schedule");
            }
          }
        });
      });
    }

    this.showTooltip = (element: HTMLElement, data: any) => {
      
      element.addEventListener("mouseenter", (event) => {
        this.schedules.forEach(schedule => { 
          if(data.row.label == (schedule.resource.firstName + ' ' + schedule.plannedStartTime.substring(11,19))) {
            schedule.scheduledVisits.forEach(visit => {
              if(visit.customerName == data.item.label) {
                let label = 'Name: '+data.item.label+'\n'+'Scheduled Time: '+ visit.plannedVisitTime;
                schedule.odDtoList.forEach(orderDTO => {
                  if(orderDTO.orderInfo.receiverName == visit.customerName) {
                    if(orderDTO.orderInfo.actualDeliveryDatetime) {
                      label += '\n'+'Pick Up Time: '+ orderDTO.orderInfo.actualDeliveryDatetime.substring(11,19);
                    }
                  }
                });
                element.title = label;
              }
            });
          }
        });
      });
    }
  }

  zoomChange() {
    this.gstcState.update("config.chart.time.zoom", this.zoom);
  }

  onState(state) {
    this.gstcState = state;
   /*  console.log(this.gstcState);
    const time = this.gstcState.get('_internal.chart.time');
    console.log(this.gstcState.data.config);
    const toTime = new Date().getTime();
    this.gstcState.update('config.scroll', scroll => {
      const chartWidth = this.gstcState.get('_internal.chart.dimensions.width');
      const halfTime = (chartWidth / 2) * time.timePerPixel;
      const leftGlobal = toTime - halfTime - time.finalFrom;
      scroll.left = this.limitScroll('left', Math.round(leftGlobal / time.timePerPixel));
      return scroll;
    }); */
  }

  limitScroll(which, scroll) {
    if (which === 'top') {
      const height = this.gstcState.get('_internal.list.rowsHeight') - this.gstcState.get('_internal.height');
      if (scroll < 0) {
        scroll = 0;
      } else if (scroll > height) {
        scroll = height;
      }
      return Math.round(scroll);
    } else {
      const width =
        this.gstcState.get('_internal.chart.time.totalViewDurationPx') - this.gstcState.get('_internal.chart.dimensions.width');
      if (scroll < 0) {
        scroll = 0;
      } else if (scroll > width) {
        scroll = width;
      }
      return Math.round(scroll);
    }
  }

  routeChanged() {
    if(this.routeName == 'All Routes') {
      //this.isShown = false;
    }else {
      this.gstcState.update("config.list.columns.data.label.header.content", this.routeName);
      this.routes = [];
      this.items = {};
      this.rows = {};
      this.generateData();
      this.gstcState.update('config.list.rows', this.rows);
      this.gstcState.update('config.chart.items', this.items);
      //this.isShown = true;
    }
  }

  generateData() {
    let k = 0;
    let l = 0;
    this.scheduled = 0;
    this.completed = 0;
    this.inTransit = 0;
    for(let i = 0; i < this.schedules.length; i++) {
      if(this.routeNames.indexOf(this.schedules[i].routeName) === -1) {
        this.routeNames.push(this.schedules[i].routeName);
      }
      
      if(this.routeName == this.schedules[i].routeName) {
        this.routes.push(this.schedules[i].resource.firstName + ' ' + this.schedules[i].plannedStartTime.substring(11,19));
        const id = l.toString();
        this.rows[id] = {
          id,
          label: this.schedules[i].resource.firstName + ' ' + this.schedules[i].plannedStartTime.substring(11,19),
          expanded: false,      
        };

        this.rowTripMapping.push({
          rowId: id,
          trip: this.schedules[i].trip
        });
        
        if(this.schedules[i].trip && this.schedules[i].trip.tState == 'TRIP_STATE_IN_TRANSIT') {
          this.inTransit++;
          this.schedules[i].odDtoList.forEach(odDTO => {
            for(let j = 0; j < this.schedules[i].scheduledVisits.length; j++) {
              if(odDTO.orderInfo.receiverName == this.schedules[i].scheduledVisits[j].customerName) {
                const id = k.toString();
                k++;

                let tmp = new Date();
                tmp.setHours(parseInt(this.schedules[i].scheduledVisits[j].plannedVisitTime.substring(0, 2)), parseInt(this.schedules[i].scheduledVisits[j].plannedVisitTime.substring(3, 5)), 0, 0);
                let start = tmp.getTime();
                let end;

                if(j < this.schedules[i].scheduledVisits.length-1) {
                  tmp.setHours(parseInt(this.schedules[i].scheduledVisits[j+1].plannedVisitTime.substring(0, 2)), parseInt(this.schedules[i].scheduledVisits[j+1].plannedVisitTime.substring(3, 5)), 0, 0);
                  end = tmp.getTime(); 
                }else {
                  end = start + this.fifteenMinutes;
                }

                if(odDTO.orderInfo.oState == 'ORDER_STATE_IN_TRANSIT') {
                  this.items[id] = {
                    id,
                    label: this.schedules[i].scheduledVisits[j].customerName,
                    time: {
                      start: start,
                      end: end
                    },
                    rowId: l,
                    style: { background: 'yellow',  color: 'black' }
                  };

                  let visitDateTime = new Date(odDTO.orderInfo.deliveryETADateTime);
                  let currentDateTime = new Date();
                  if(visitDateTime < currentDateTime) {
                    this.items[id].style.background = '#FC322B';
                    this.items[id].style.color = 'white';
                  }

                }

                if(odDTO.orderInfo.oState == 'ORDER_STATE_FAILED') {
                  this.items[id] = {
                    id,
                    label: this.schedules[i].scheduledVisits[j].customerName,
                    time: {
                      start: start,
                      end: end
                    },
                    rowId: l,
                    style: { background: 'red' }
                  };

                  let visitDateTime = new Date(odDTO.orderInfo.deliveryETADateTime);
                  let actualDeliveryDatetime = new Date(odDTO.orderInfo.actualDeliveryDatetime);
                  if(visitDateTime < actualDeliveryDatetime) {
                    this.items[id].style.background = '#FC322B';
                  }
                }

                if(odDTO.orderInfo.oState == 'ORDER_STATE_DELIVERED') {
                  this.items[id] = {
                    id,
                    label: this.schedules[i].scheduledVisits[j].customerName,
                    time: {
                      start: start,
                      end: end
                    },
                    rowId: l,
                    style: { background: 'green' }
                  };

                  let visitDateTime = new Date(odDTO.orderInfo.deliveryETADateTime);
                  let actualDeliveryDatetime = new Date(odDTO.orderInfo.actualDeliveryDatetime);
                  if(visitDateTime < actualDeliveryDatetime) {
                    this.items[id].style.background = '#FC322B';
                  }
                }
              }
            }
          });
        }else if(this.schedules[i].trip && this.schedules[i].trip.tState == 'TRIP_STATE_COMPLETED'){
          this.completed++;
          for(let j = 0; j < this.schedules[i].scheduledVisits.length; j++) {
            this.schedules[i].odDtoList.forEach(odDTO => {
              if(odDTO.orderInfo.receiverName == this.schedules[i].scheduledVisits[j].customerName) {
                const id = k.toString();
                k++;
                let tmp = new Date();
                tmp.setHours(parseInt(this.schedules[i].scheduledVisits[j].plannedVisitTime.substring(0, 2)), parseInt(this.schedules[i].scheduledVisits[j].plannedVisitTime.substring(3, 5)), 0, 0);
                let start = tmp.getTime();
                let end;
                if(j < this.schedules[i].scheduledVisits.length-1) {
                  tmp.setHours(parseInt(this.schedules[i].scheduledVisits[j+1].plannedVisitTime.substring(0, 2)), parseInt(this.schedules[i].scheduledVisits[j+1].plannedVisitTime.substring(3, 5)), 0, 0);
                  end = tmp.getTime(); 
                }else {
                  end = start + this.fifteenMinutes;
                }
                this.items[id] = {
                  id,
                  label: this.schedules[i].scheduledVisits[j].customerName,
                  time: {
                    start: start,
                    end: end
                  },
                  rowId: l,
                  style: { background: 'green' }
                };

                let visitDateTime = new Date(odDTO.orderInfo.deliveryETADateTime);
                let actualDeliveryDatetime = new Date(odDTO.orderInfo.actualDeliveryDatetime);
                if(visitDateTime < actualDeliveryDatetime) {
                  this.items[id].style.background = '#FC322B';
                }
              }  
            });
          }
        }else {
          this.scheduled++;
          let color = '#0f71e2';
          let plannedStartTime = new Date(this.schedules[i].plannedStartTime);
          plannedStartTime.setDate(new Date().getDate());
          plannedStartTime.setMonth(new Date().getMonth());
          if(plannedStartTime < new Date()) {
            color = '#FC322B';
          }
          for(let j = 0; j < this.schedules[i].scheduledVisits.length; j++) {
            const id = k.toString();
            k++;
            let tmp = new Date();
            tmp.setHours(parseInt(this.schedules[i].scheduledVisits[j].plannedVisitTime.substring(0, 2)), parseInt(this.schedules[i].scheduledVisits[j].plannedVisitTime.substring(3, 5)), 0, 0);
            let start = tmp.getTime();
            let end;
            if(j < this.schedules[i].scheduledVisits.length-1) {
              tmp.setHours(parseInt(this.schedules[i].scheduledVisits[j+1].plannedVisitTime.substring(0, 2)), parseInt(this.schedules[i].scheduledVisits[j+1].plannedVisitTime.substring(3, 5)), 0, 0);
              end = tmp.getTime(); 
            }else {
              end = start + this.fifteenMinutes;
            }
            this.items[id] = {
              id,
              label: this.schedules[i].scheduledVisits[j].customerName,
              time: {
                start: start,
                end: end
              },
              rowId: l,
              style: { background: color }
            };
          }
        }
        l++;
      }
    }
  }
}
